exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.rates[data-v-62d0602f] {\n  line-height: 2;\n}\n.rates-icon[data-v-62d0602f] {\n  color: #3db152;\n}\n.fa-home[data-v-62d0602f] {\n  font-size: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-62d0602f","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/jobs/JobRates.vue
// module id = 1jbe
// module chunks = 0